import React, { Component } from 'react';
import { connect } from 'react-redux';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import { FeatureFlagEnum } from '../../utils/enums';

const log = new Logger('PROCESSED_DOCUMENTS_ITEM', LOG_LEVELS.DEBUG);
const showSelectAll = false;

class ProcessedDocumentsListRow extends Component {
  onChange(event) {
    log.debug('onChange():  ', event);
    if (typeof this.props.onSelect === 'function') return this.props.onSelect(event.target.checked);
  }

  render() {
    log.debug('render(): ', this.props);
    const enableCompanyCodeProcessedDocumentsGrid = this.props.featureFlags?.[FeatureFlagEnum.ENABLE_COMPANYCODE_PROCESSED_DOCUMENTS_GRID];

    if (this.props.header) {
      return (
        <tr>
          <th><LanguageStringResolver string='processedDocuments_fileName' /></th>
          <th><LanguageStringResolver string='processedDocuments_dateProcessed' /></th>
          {enableCompanyCodeProcessedDocumentsGrid && (
            <th><LanguageStringResolver string='processedDocuments_companyCode' /></th>
          )}
          <th><LanguageStringResolver
            string={enableCompanyCodeProcessedDocumentsGrid
              ? "processedDocuments_companyName"
              : "processedDocuments_company"
            }
          /></th>
          <th><LanguageStringResolver string='processedDocuments_processed' /></th>
          <th><LanguageStringResolver string='processedDocuments_error' /></th>
          <th><LanguageStringResolver string='processedDocuments_onHold' /></th>
          <th><LanguageStringResolver string='processedDocuments_pending' /></th>
          <th><LanguageStringResolver string='processedDocuments_totalNumber' /></th>
          {
            (() => {
              if (!this.props.forExport) {
                return (
                  (showSelectAll) ? (
                    <th>
                      {
                        this.props.formInitialising ? (<span></span>) :
                          (<fieldset>
                            <input className="mt0 checkbox absolute" checked={this.props.selected} type="checkbox" onChange={this.onChange.bind(this)} />
                            <label className="ml15 mt0 checkbox"><LanguageStringResolver string='processedDocuments_selectUnselectAll' /></label>
                          </fieldset>)
                      }
                    </th>
                  ) : (<th></th>)
                );
              }
            })()
          }

        </tr>
      )
    }

    const document = this.props.document || {};
    let processingDate = document.processingDate;

    if (processingDate === null) {
      processingDate = LANGUAGES_CONTROLLER.format(this.props.languages, 'Processing');
    }
    else if (typeof processingDate !== 'string') {
      processingDate = LANGUAGES_CONTROLLER.format(this.props.languages, 'Unknown');
    } else {
      processingDate = processingDate.substr(0, 10);
    }

    let linkToDrillDown = true;
    (this.props.forExport) ? linkToDrillDown = false : linkToDrillDown = true;

    return (
      <tr>
        {
          linkToDrillDown ?
            <td>
              <a onClick={this.props.loadDocumentDetails} className="tertiary">{document.fileName}</a>
            </td>
            :
            <td>
              {document.fileName}
            </td>
        }
        <td>{processingDate}</td>
        {enableCompanyCodeProcessedDocumentsGrid && (
          <td>{document.userCode}</td>
        )}
        <td>{document.userName}</td>
        <td>{document.processedCount}</td>
        <td>{document.errorCount}</td>
        <td>{document.onholdCount}</td>
        <td>{document.inboxCount}</td>
        <td>{document.processedCount + document.errorCount + document.onholdCount}</td>
        {
          (() => {
            if (!this.props.forExport) {
              return (<td style={{ minWidth: "100px" }}>
                {
                  (this.props.formInitialising || document.id === null) ? (<span></span>) :
                    (<fieldset>
                      <input className="checkbox" checked={this.props.selected} type="checkbox" onChange={this.onChange.bind(this)} />
                      <label className="checkbox"><LanguageStringResolver string='processedDocuments_selectEach' /></label>
                    </fieldset>)
                }
              </td>);
            }
          })()
        }

      </tr>

    );
  }
}
function mapStateToProps(state, props) {
  log.debug('mapStateToProps: ', state);
  const defaultCompanyList = (state.companies && state.companies.data) || [];
  return {
    languages: state.languages,
    companyList: props.companyList || defaultCompanyList,
    featureFlags: state.featureFlag && state.featureFlag.data
  };
}
ProcessedDocumentsListRow.defaultProps = {
  none: false,
  header: false,
  formInitialising: false,
  selected: false,
  forExport: false,
  onSelect: () => { },
};

export default connect(mapStateToProps)(ProcessedDocumentsListRow);
